import { render } from "./RecommendationCardComponent.vue?vue&type=template&id=8a62e838&ts=true"
import script from "./RecommendationCardComponent.vue?vue&type=script&lang=ts"
export * from "./RecommendationCardComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__